var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from '@folio/stripes/core';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import { useMutation } from 'react-query';
import { computeErrorMessage, t } from '../../services';
import { useMessages } from '../useMessages';
import { useCSVExportCancel } from './useCSVExportCancel';
import { useCSVExportPolling } from './useCSVExportPolling';
import { useVisibleColumns } from '../useVisibleColumns';
export var useCSVExport = function (_a) {
    var _b, _c, _d;
    var listId = _a.listId, listName = _a.listName, listDetails = _a.listDetails;
    var _e = useMessages(), showSuccessMessage = _e.showSuccessMessage, showErrorMessage = _e.showErrorMessage;
    var ky = useOkapiKy();
    var values = useLocalStorage('listIdsToExport', {})[0];
    var unlinkedValue = __assign({}, values);
    var removeListFromStorage = function () {
        delete unlinkedValue[listId];
        writeStorage('listIdsToExport', unlinkedValue);
    };
    var getExportIdFormStorage = function () {
        return values[listId];
    };
    var poll = useCSVExportPolling(listName, function () {
        removeListFromStorage();
    });
    var columnsToExport = (_c = (_b = useVisibleColumns(listId).visibleColumns) !== null && _b !== void 0 ? _b : listDetails === null || listDetails === void 0 ? void 0 : listDetails.fields) !== null && _c !== void 0 ? _c : [];
    var _f = useMutation({
        mutationFn: function () { return ky.post("lists/".concat(listId, "/exports"), { json: columnsToExport }).json(); },
        onSuccess: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var _c;
            var exportId = _b.exportId;
            return __generator(this, function (_d) {
                showSuccessMessage({
                    message: t('callout.list.csv-export.begin', {
                        listName: listName,
                    }),
                });
                writeStorage('listIdsToExport', __assign(__assign({}, values), (_c = {}, _c[listId] = exportId, _c)));
                poll(listId, exportId);
                return [2 /*return*/];
            });
        }); },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.csv-export.error', { listName: listName })];
                    case 1:
                        errorMessage = _a.sent();
                        showErrorMessage({ message: errorMessage });
                        removeListFromStorage();
                        return [2 /*return*/];
                }
            });
        }); },
    }), isLoading = _f.isLoading, mutateAsync = _f.mutateAsync, data = _f.data;
    var _g = useCSVExportCancel({
        listId: listId,
        exportId: (_d = data === null || data === void 0 ? void 0 : data.exportId) !== null && _d !== void 0 ? _d : getExportIdFormStorage(),
        onSuccess: function () {
            showSuccessMessage({ message: t('callout.list.csv-export.cancel', { listName: listName }) });
            removeListFromStorage();
        },
        onError: function (error) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.csv-export.cancel-error', { listName: listName })];
                        case 1:
                            errorMessage = _a.sent();
                            showErrorMessage({ message: errorMessage });
                            removeListFromStorage();
                            return [2 /*return*/];
                    }
                });
            }); })();
        },
    }), cancelInProgress = _g.cancelInProgress, cancelExport = _g.cancelExport;
    return {
        requestExport: mutateAsync,
        isExportInProgress: isLoading || Boolean(values[listId]),
        cancelExport: cancelExport,
        isCancelExportInProgress: cancelInProgress,
    };
};
